import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Conditional, Money as MoneyField, NumberValidator, RequiredValidator, Select, Switch, TextField } from '../../Components/Form';
import { ulid } from 'ulid';
import Alert from '../../Components/Alert';
import {getServiceString} from '../../Components/Formatting/Services';
import { useServices } from '../../Data/Services';

const AddLoyaltyCard = ({customer, addLoyaltyCard, isOpen, setIsOpen}) => {
    return <Modal title="Add loyalty card" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer, addLoyaltyCard}} />}
    </Modal>
}

const Inner = ({customer, addLoyaltyCard}) => {
    const {services} = useServices();

    const data = {
        customerId: customer.id,
        loyaltyCardId: ulid(),
    }

    if (!customer.jobs?.length) {
        return <Alert type="info" title="No jobs" message="The customer needs at least one job to add a loyalty card" />
    }

    const jobs = customer.jobs.map(job => {
        const serviceStr = getServiceString(job.services, services);
        return {
            value: job.id,
            label: job.title ?? `#${job.shortId} (${serviceStr})`,
        }
    })

    return <Form data={data} onSubmit={addLoyaltyCard} closeModalOnSubmit>
        <Select name="creditingJobId"
            label="Crediting Job"
            unselected="Select a job"
            options={jobs}
            validators={[RequiredValidator]}
            help="The loyalty card will get a point each time this job is completed"
        />
        <Select name="redeemingJobId"
            label="Redeeming Job"
            unselected="Select a job"
            options={jobs}
            validators={[RequiredValidator]}
            help="Once the loyalty card has enough points, it can be redeemed against this job"
        />
        <TextField name="requiredPoints"
            type="number"
            label="Required points"
            validators={[RequiredValidator]}
            help="The number of points the loyalty card needs before it can be redeemed"
        />
        <Select name="rewardType"
            label="Reward type"
            unselected="Select a reward type"
            options={[
                {value: 'Free', label: 'Free job'},
                {value: 'Cash', label: 'Cash discount'},
                {value: 'Percent', label: 'Percent discount'},
            ]}
            validators={[RequiredValidator]}
            help={(v) => {
                switch (v) {
                    case 'Free':
                        return 'The customer will get the redeeming job for free (100% discount)';
                    case 'Cash':
                        return 'The customer will get a fixed cash value discount';
                    case 'Percent':
                        return 'The customer will get a percentage of the redeeming job cost discounted';
                    default:
                        return null;
                }
            }}
        />
        <Conditional condition={(data) => data.rewardType === 'Cash'}>
            <MoneyField name="rewardValue"
                label="Reward value"
                validators={[RequiredValidator]}
            />
        </Conditional>
        <Conditional condition={(data) => data.rewardType === 'Percent'}>
            <TextField name="rewardValue"
                label="Reward value"
                suffix="%"
                validators={[RequiredValidator, NumberValidator(0, 100)]}
            />
        </Conditional>
        <Switch name="autoRepeat"
            label="Automatically replace"
            help={(v) => v ?
                'The customer will automatically get another loyalty card with the same settings each time it is redeemed' :
                'No replacement card will be issued when this card is redeemed'
            }
        />
        <Actions submit={{label: 'Add'}} cancel />
    </Form>
}


export default AddLoyaltyCard;
